<template>
  <div>
    <Portal to="lefSideBar">
      <LoginForm role="teacher" />
    </Portal>
  </div>
</template>

<script>
import { Portal } from 'portal-vue';
import LoginForm from '@/components/login/Form.vue';
import { loggedIn, isLoginPath } from '@/helpers/Authentication.js';

export default {
  components: {
    Portal,
    LoginForm,
  },
  computed: {
    ...loggedIn,
  },
  created() {
    if (this.loggedIn && isLoginPath(this.$route.fullPath)) {
      this.$router.push({ name: 'home' });
    }
  },
};
</script>
